<template>


<div class="box_1 flex-col">
  <el-drawer
       
       :visible.sync="drawer1"
       :direction="direction"
       size="50%"
      >
      <router-link to='/home' >
      <div class="text-wrapper_w25 flex-col"><span class="text_w67" :class="[this.url === '/home'?'select_menu':'no_select_menu']">首页</span></div>
      </router-link>
      <router-link to='/solution_h5' >
       <div class="text-wrapper_w26 flex-col"><span class="text_w68" :class="[this.url === '/solution_h5'?'select_menu':'no_select_menu']">解决方案</span></div>
     </router-link>  
     <router-link to='/re_ass'>
       <div class="text-wrapper_w27 flex-col"><span class="text_w69" :class="[this.url === '/re_ass'?'select_menu':'no_select_menu']">康复助手</span></div>
     </router-link> 
       <div class="text-wrapper_w28 flex-col" :class="[this.url === '/workstation'|| this.url === '/e26' ||this.url === '/evaluation'?'select_menu':'no_select_menu']" @click="opens"><span class="text_w70">产品介绍 <i v-if="show" class="el-icon-arrow-right"></i><i v-if="!show" class="el-icon-arrow-down"></i></span></div>
      
     <router-link to="/workstation_h5">
      <div v-if="show" class="text-wrapper_s28 flex-col" :class="[this.url === '/workstation_h5'?'select_menu':'no_select_menu']"><span class="text_s70">通用医疗运动处方工作站</span></div>
     </router-link> 
     <router-link to="e26_h5">
         
      <div v-if="show" class="text-wrapper_s28 flex-col" :class="[ this.url === '/e26_h5' ?'select_menu':'no_select_menu']"><span class="text_s70">PF-E26智能运动处方一体机</span></div>
     </router-link> 
     <router-link to="/evaluation_h5">
      <div v-if="show" class="text-wrapper_s28 flex-col" :class="[this.url === '/evaluation_h5'?'select_menu':'no_select_menu']"><span class="text_s70">健康体适能测评仪</span></div>
     </router-link> 
     <router-link to="/quotation_1">
      <div class="text-wrapper_w29 flex-col" ><span class="text_w71" :class="[this.url === '/quotation_2' || this.url === '/quotation_1' ||this.url === '/quotation_3'?'select_menu':'no_select_menu']">功能及报价</span></div>
     </router-link>
     <router-link to="/about_us">
      <div class="text-wrapper_w30 flex-col" ><span class="text_w72" :class="[this.url === '/about_us'?'select_menu':'no_select_menu']">关于我们</span></div>
     </router-link>
      
       
     
     </el-drawer>
        <div class="image-wrapper_2 flex-col">
          <img
            class="label_2"
            @click="open"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG885af8a4fc0fe958696917aa63620abf.png"
          />
        </div>
      </div>
  
</template>


  
  <script>
    export default {
      data() {
        return {
          show:false,
          drawer1: false,
          direction: 'rtl',
          activeIndex: '1',
          activeIndex2: '1',
          url: '/lanhu_shouyegaiban'
        };
      },
      async mounted(){
        this.url = this.$route.path
          console.log(this.$route.path)
      },
      methods: {
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        },
        toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
        },
        opens(){
          this.show = !this.show
        },
        open(){
        console.log('44444444444444')
        this.drawer1 = true
      }
      }
    }
  </script>
  <style scoped lang="css" src="./assets/index.response.css" />
